import { render, staticRenderFns } from "./ResourceConstraintPage.vue?vue&type=template&id=6cc5db35"
import script from "./ResourceConstraintPage.vue?vue&type=script&lang=ts"
export * from "./ResourceConstraintPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports